import React from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from '@material-ui/core';
import { ExpansionPanelProps } from '@material-ui/core/ExpansionPanel';
import { PaperProps } from '@material-ui/core/Paper';

import { ChevronDownIcon } from '../icon/solid';


const useStyles = makeStyles(({ colors }: Theme) => createStyles({
  panelRoot: {
    '&, &$expanded': {
      margin: 'initial',
    },
    '&:before': {
      backgroundColor: 'initial',
    },
  },
  summaryRoot: {
    color: colors.unselected,
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.21px',
    borderBottom: `2px solid ${colors.outlines}`,
    padding: '0 4px',

    '&, &$expanded': {
      minHeight: 'initial',
    },
  },
  summaryContent: {
    '&, &$expanded': {
      margin: '4px 0',
    },
  },
  summaryExpandIcon: {
    padding: '6px',
    marginRight: '4px',
  },
  expandIcon: {
    color: colors.unselected,
    height: '18px',
    width: '18px',
  },
  details: {
    paddingTop: '1.5em',
  },
  expanded: {},
}), { name: 'CollapsableSection' });

type Props = Omit<ExpansionPanelProps, Exclude<keyof PaperProps, 'onChange'> | 'classes'> & {
  title: React.ReactNode;
  children: React.ReactNode;
};

const CollapsableSection = ({
  title,
  children,
  ...props
}: Props) => {
  const classes = useStyles();

  return (
    <ExpansionPanel
      elevation={0}
      square
      {...props}
      classes={{
        root: classes.panelRoot,
        expanded: classes.expanded,
      }}
    >
      <ExpansionPanelSummary
        expandIcon={<ChevronDownIcon className={classes.expandIcon} />}
        aria-controls="panel-content"
        classes={{
          root: classes.summaryRoot,
          content: classes.summaryContent,
          expandIcon: classes.summaryExpandIcon,
          expanded: classes.expanded,
        }}
      >
        {title}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails
        className={classes.details}
      >
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default CollapsableSection;
